export const MENU_ROUTES: Array<{ key: string; routes: string[]; openKeys?: string[] }> = [
  // Dashboard
  { key: 'dashboard', routes: ['dashboard'] },

  // Projects
  { key: 'projects', routes: ['projects', 'projectShow', 'projectEdit'] },

  // Project Websites
  { key: 'projectWebsites', routes: ['projectWebsites', 'projectWebsiteEdit'] },

  // Buildings
  { key: 'buildings', routes: ['buildings', 'buildingShow', 'buildingEdit'], openKeys: ['buildingItems'] },
  { key: 'fivePercentRules', routes: ['fivePercentRules'], openKeys: ['buildingItems'] },

  // Reports
  { key: 'reports', routes: [], openKeys: ['reports'] }, // adjust if you later add child routes

  // Buyers
  { key: 'customers', routes: ['customers', 'customerShow', 'customerEdit'], openKeys: ['buyers'] },
  { key: 'customerUsers', routes: ['customerUsers', 'customerUserShow', 'customerUserEdit'], openKeys: ['buyers'] },

  // Tenants
  { key: 'tenants', routes: ['tenants', 'tenantShow', 'tenantEdit'], openKeys: ['tenants'] },
  { key: 'tenantUsers', routes: ['tenantUsers', 'tenantUserShow', 'tenantUserEdit'], openKeys: ['tenants'] },

  // Layouts / Elements / Options
  { key: 'layouts', routes: ['layouts', 'layoutShow', 'layoutEdit'] },
  { key: 'elements', routes: ['elements', 'elementShow', 'elementEdit'] },
  { key: 'revitElements', routes: ['revitElements'] },
  { key: 'subelements', routes: ['subelements', 'subelementShow', 'subelementEdit'] },
  { key: 'options', routes: ['options', 'optionShow', 'optionEdit'] },

  // Configs
  { key: 'buildingConfigs', routes: ['buildingConfigs', 'buildingConfigShow'], openKeys: ['configs'] },
  { key: 'demoConfigs', routes: ['demoConfigs'], openKeys: ['configs'] },

  // Orders
  { key: 'orders', routes: ['orders', 'orderShow'], openKeys: ['allOrders'] },
  { key: 'oldWoononOrders', routes: ['oldWoononOrders', 'oldWoononOrderShow'], openKeys: ['allOrders'] },

  // Suppliers
  { key: 'companies', routes: ['companies', 'companyShow', 'companyEdit'], openKeys: ['suppliers'] },
  { key: 'companyUsers', routes: ['companyUsers', 'companyUserShow', 'companyUserEdit'], openKeys: ['suppliers'] },

  // Communication
  { key: 'news', routes: ['news'], openKeys: ['communication'] },
  { key: 'messages', routes: ['messages', 'messageCreate', 'messageShow'], openKeys: ['communication'] },
  { key: 'system-messages', routes: ['systemMessages', 'systemMessageCreate', 'systemMessageShow'], openKeys: ['communication'] },

  // Surveys
  { key: 'surveys', routes: ['surveys', 'surveyShow', 'surveyEdit'], openKeys: ['surveys'] },
  { key: 'deliveries', routes: ['deliveries'], openKeys: ['surveys'] },
  { key: 'surveyForms', routes: ['surveyForms', 'surveyFormCreate', 'surveyFormEdit'], openKeys: ['surveys'] },

  // KAM
  { key: 'kamDashboard', routes: ['kamDashboard'], openKeys: ['kam'] },
  { key: 'kamForms', routes: ['kamForms', 'kamFormEdit'], openKeys: ['kam'] },
  { key: 'kamFormCreate', routes: ['kamFormCreate'], openKeys: ['kam'] },
  { key: 'kamIncidentOverview', routes: ['kamIncidentOverview'], openKeys: ['kam'] },

  // Service
  { key: 'issues', routes: ['issues', 'issueEdit'], openKeys: ['service'] },
  { key: 'questions', routes: ['questions', 'questionEdit'], openKeys: ['service'] },
  { key: 'objections', routes: ['objections', 'objectionEdit'], openKeys: ['service'] },

  // Financial
  { key: 'guardCodes', routes: ['guardCodes', 'guardCodeShow', 'guardCodeEdit'], openKeys: ['financial'] },
  { key: 'invoiceRules', routes: ['invoiceRules'], openKeys: ['financial'] },
  { key: 'budgets', routes: ['budgets', 'budgetShow', 'budgetBatchShow'], openKeys: ['financial'] },
  { key: 'financialReports', routes: ['financialReports'], openKeys: ['financial'] },

  // Feedback / Settings
  { key: 'feedbacks', routes: ['feedbacks', 'feedbackShow'] },
  { key: 'settings', routes: ['settings'] },

  // Logout (no routes, just button)
  { key: 'logout', routes: [] }
]

// Build reverse index
export const ROUTE_TO_MENU = MENU_ROUTES.reduce((acc, grp) => {
  grp.routes.forEach(r => {
    acc[r] = { key: grp.key, openKeys: grp.openKeys || [] }
  })
  return acc
}, {} as Record<string, { key: string; openKeys: string[] }>)
